function PagesIcon() {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.21736 7.95654H2.73912C2.27789 7.95654 1.83552 8.13976 1.50938 8.4659C1.18324 8.79207 1 9.23441 1 9.69566V39.2608C1 39.722 1.18324 40.1644 1.50938 40.4904C1.83552 40.8166 2.27789 40.9999 2.73912 40.9999H32.3042C32.7655 40.9999 33.2079 40.8166 33.5339 40.4904C33.86 40.1644 34.0433 39.722 34.0433 39.2608V35.7824"
        fill="#B2B2B2"
      />
      <path
        d="M6.21736 7.95654H2.73912C2.27789 7.95654 1.83552 8.13976 1.50938 8.4659C1.18324 8.79207 1 9.23441 1 9.69566V39.2608C1 39.722 1.18324 40.1644 1.50938 40.4904C1.83552 40.8166 2.27789 40.9999 2.73912 40.9999H32.3042C32.7655 40.9999 33.2079 40.8166 33.5339 40.4904C33.86 40.1644 34.0433 39.722 34.0433 39.2608V35.7824"
        stroke="#191919"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41 2.73912C41 2.27789 40.8168 1.83552 40.4906 1.50938C40.1644 1.18324 39.7221 1 39.2608 1H7.95665C7.4954 1 7.05305 1.18324 6.72691 1.50938C6.40076 1.83552 6.21753 2.27789 6.21753 2.73912V34.0433C6.21753 34.5046 6.40076 34.9469 6.72691 35.2731C7.05305 35.5993 7.4954 35.7824 7.95665 35.7824H39.2608C39.7221 35.7824 40.1644 35.5993 40.4906 35.2731C40.8168 34.9469 41 34.5046 41 34.0433V2.73912Z"
        fill="#E3E3E3"
      />
      <path
        d="M6.73927 35.2608L40.4922 1.50784C40.3304 1.34644 40.1382 1.21851 39.927 1.13137C39.7157 1.04424 39.4893 0.999597 39.2608 1H7.95665C7.4954 1 7.05305 1.18324 6.72691 1.50938C6.40076 1.83553 6.21753 2.27789 6.21753 2.73912V34.0433C6.22406 34.502 6.41158 34.9397 6.73927 35.2608Z"
        fill="white"
      />
      <path
        d="M41 2.73912C41 2.27789 40.8168 1.83552 40.4906 1.50938C40.1644 1.18324 39.7221 1 39.2608 1H7.95665C7.4954 1 7.05305 1.18324 6.72691 1.50938C6.40076 1.83552 6.21753 2.27789 6.21753 2.73912V34.0433C6.21753 34.5046 6.40076 34.9469 6.72691 35.2731C7.05305 35.5993 7.4954 35.7824 7.95665 35.7824H39.2608C39.7221 35.7824 40.1644 35.5993 40.4906 35.2731C40.8168 34.9469 41 34.5046 41 34.0433V2.73912Z"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.167 7.95117H34.0366"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.167 14.9082H34.0366"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.167 21.8643H34.0366"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.167 28.8208H22.7392"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default PagesIcon;
